'use strict';

var Misc = require('utils/misc');

var BarController = {};

BarController.initData = function (config) {
    config.units = config.units || [];

    // colors for each bar-group
    // for more than two bars per group, extend tc-background-* and tc-* in widget.less
    // and extend the colors-array below
    var colors = ['primary', 'grey'];

    config.columnCount = 1;

    var data = [];

    // get the heights in pixel for each bar. The highest value is assigned 100px,
    // and the remaining values are scaled accordingly
    _.each(
        config.dataSets,
        function (dataSet, idx) {
            data.push(
                this.prepareData({
                    data: dataSet,
                    unit: config.units[idx],
                    names: config.columns,
                })
            );
        },
        this
    );

    config.data = [];
    for (var i = 0; i < data[0].length; i++) {
        var bars = [];
        _.each(data, function (bar, idx) {
            // if there are more bars than colors, cycle through the colors
            bar[i].color = colors[idx % colors.length];
            bars.push(bar[i]);
        });
        config.data.push({ bar: bars, name: config.columns[i] });
    }
    config.columnCount = data.length || 1;

    config.legendItems = [];
    _.each(config.legend, function (text, idx) {
        config.legendItems.push({ color: colors[idx % colors.length], text: text });
    });

    return config;
};

BarController.prepareData = function (config) {
    if (!config.data) {
        return;
    }

    var valuesMax = 1;
    var displayInfo = {};
    var displayData = [];

    // get the maximum value of the data
    valuesMax = Math.max.apply(Math, config.data);

    // calculated the height of each bar and format the value to be displayed
    _.each(config.data, function (value, idx) {
        if (config.unit) {
            displayInfo = Misc.getValueDisplayInfos(value, 'MBR', undefined, config.unit);
        } else {
            displayInfo = { value: value };
        }

        displayInfo.height = (value / valuesMax) * 100 || 2;
        displayInfo.value = Math.round(displayInfo.value);

        displayData.push(displayInfo);
    });

    return displayData;
};

module.exports = BarController;
